export const categories = [
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门国产电视剧高清全集在线观看',
    color: 'primary',
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '最新国产电影高清在线播放',
    color: 'accent',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-happy-line',
    description: '热门综艺节目免费在线观看',
    color: 'secondary',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-global-line',
    description: '精品国产纪录片全集在线播放',
    color: 'primary',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '国产动漫高清全集在线观看',
    color: 'accent',
  },
  {
    slug: 'shaoer',
    name: '少儿',
    icon: 'ri-star-line',
    description: '优质少儿节目免费在线播放',
    color: 'secondary',
  },
];

export const hotVideos = [
  {
    id: 1,
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'dianshiju',
    rating: 9.2,
    year: 2024,
    updateInfo: '更新至48集/共48集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20style%2C%20ancient%20Chinese%20city%20atmosphere%2C%20cinematic%20photography%2C%20dramatic%20warm%20lighting%2C%20Tang%20dynasty%20aesthetic%2C%20professional%20movie%20poster%20composition%2C%20clean%20background&width=400&height=533&seq=hot-video-01&orientation=landscape',
  },
  {
    id: 2,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'dianying',
    rating: 8.8,
    year: 2025,
    updateInfo: 'HD高清',
    image: 'https://readdy.ai/api/search-image?query=sci-fi%20Chinese%20movie%20poster%20style%2C%20space%20exploration%20theme%2C%20cinematic%20photography%2C%20dramatic%20cool%20and%20warm%20contrast%20lighting%2C%20futuristic%20aesthetic%2C%20professional%20movie%20poster%20composition&width=400&height=533&seq=hot-video-02&orientation=landscape',
  },
  {
    id: 3,
    title: '向往的生活第八季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: 8.5,
    year: 2025,
    updateInfo: '更新至12期',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20style%2C%20countryside%20pastoral%20scene%2C%20warm%20natural%20lighting%2C%20relaxing%20atmosphere%2C%20green%20fields%20and%20wooden%20house%2C%20professional%20photography%20composition&width=400&height=533&seq=hot-video-03&orientation=landscape',
  },
  {
    id: 4,
    title: '大国重器第三季',
    category: '纪录片',
    categorySlug: 'jilupian',
    rating: 9.5,
    year: 2025,
    updateInfo: '全6集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20poster%20style%2C%20industrial%20engineering%20theme%2C%20majestic%20machinery%2C%20dramatic%20lighting%2C%20golden%20and%20deep%20blue%20tones%2C%20professional%20film%20poster%20composition&width=400&height=533&seq=hot-video-04&orientation=landscape',
  },
  {
    id: 5,
    title: '斗破苍穹年番',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 8.9,
    year: 2025,
    updateInfo: '更新至156集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20style%2C%20fantasy%20martial%20arts%20theme%2C%20dynamic%20action%20pose%2C%20fiery%20orange%20and%20gold%20color%20palette%2C%20epic%20atmosphere%2C%20professional%20illustration&width=400&height=533&seq=hot-video-05&orientation=landscape',
  },
  {
    id: 6,
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'dianshiju',
    rating: 9.0,
    year: 2024,
    updateInfo: '更新至36集/共36集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20poster%20style%2C%20ancient%20palace%20atmosphere%2C%20elegant%20composition%2C%20warm%20golden%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20professional%20film%20poster&width=400&height=533&seq=hot-video-06&orientation=landscape',
  },
  {
    id: 7,
    title: '哪吒之魔童闹海',
    category: '电影',
    categorySlug: 'dianying',
    rating: 9.4,
    year: 2025,
    updateInfo: '4K超清',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20style%2C%20mythological%20theme%2C%20fire%20and%20water%20elements%2C%20dynamic%20composition%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20fantasy%20illustration&width=400&height=533&seq=hot-video-07&orientation=landscape',
  },
  {
    id: 8,
    title: '乘风破浪的姐姐第五季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: 8.3,
    year: 2025,
    updateInfo: '更新至10期',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20reality%20show%20poster%20style%2C%20stage%20performance%20theme%2C%20glamorous%20lighting%2C%20elegant%20composition%2C%20sparkling%20gold%20and%20silver%20tones%2C%20professional%20photography&width=400&height=533&seq=hot-video-08&orientation=landscape',
  },
];

export const latestUpdates = [
  {
    id: 101,
    title: '繁花',
    category: '电视剧',
    categorySlug: 'dianshiju',
    updateTime: '2小时前更新',
    episode: '第28集',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20period%20drama%20poster%20style%2C%201990s%20Shanghai%20aesthetic%2C%20nostalgic%20warm%20lighting%2C%20cinematic%20photography%2C%20retro%20elegance%2C%20professional%20film%20poster%20composition&width=800&height=450&seq=latest-01&orientation=landscape',
  },
  {
    id: 102,
    title: '飞驰人生3',
    category: '电影',
    categorySlug: 'dianying',
    updateTime: '5小时前更新',
    episode: 'HD1080P',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20movie%20poster%20style%2C%20desert%20rally%20theme%2C%20dynamic%20motion%20blur%2C%20warm%20sunset%20lighting%2C%20adventure%20atmosphere%2C%20professional%20film%20poster&width=800&height=450&seq=latest-02&orientation=landscape',
  },
  {
    id: 103,
    title: '奔跑吧第十季',
    category: '综艺',
    categorySlug: 'zongyi',
    updateTime: '1天前更新',
    episode: '第8期',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%20style%2C%20outdoor%20adventure%20theme%2C%20bright%20sunny%20lighting%2C%20energetic%20atmosphere%2C%20colorful%20composition%2C%20professional%20photography&width=800&height=450&seq=latest-03&orientation=landscape',
  },
  {
    id: 104,
    title: '舌尖上的中国第四季',
    category: '纪录片',
    categorySlug: 'jilupian',
    updateTime: '3小时前更新',
    episode: '第5集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20style%2C%20gourmet%20cuisine%20photography%2C%20warm%20kitchen%20lighting%2C%20steaming%20dishes%2C%20rich%20textures%2C%20professional%20food%20photography%20composition&width=800&height=450&seq=latest-04&orientation=landscape',
  },
  {
    id: 105,
    title: '完美世界',
    category: '动漫',
    categorySlug: 'dongman',
    updateTime: '6小时前更新',
    episode: '第189集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20anime%20poster%20style%2C%20fantasy%20cultivation%20theme%2C%20ethereal%20mountain%20landscape%2C%20mystical%20lighting%2C%20ancient%20Chinese%20mythology%20aesthetic%2C%20professional%20illustration&width=800&height=450&seq=latest-05&orientation=landscape',
  },
  {
    id: 106,
    title: '大江大河3',
    category: '电视剧',
    categorySlug: 'dianshiju',
    updateTime: '8小时前更新',
    episode: '第33集',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20drama%20poster%20style%2C%20urban%20industrial%20theme%2C%20realistic%20lighting%2C%20reform%20era%20aesthetic%2C%20professional%20film%20poster%20composition&width=800&height=450&seq=latest-06&orientation=landscape',
  },
  {
    id: 107,
    title: '熊出没·逆转时空',
    category: '少儿',
    categorySlug: 'shaoer',
    updateTime: '1天前更新',
    episode: 'HD高清',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20children%20animation%20poster%20style%2C%20forest%20adventure%20theme%2C%20bright%20cheerful%20colors%2C%20cute%20animal%20characters%2C%20playful%20atmosphere%2C%20professional%20illustration&width=800&height=450&seq=latest-07&orientation=landscape',
  },
  {
    id: 108,
    title: '第二十条',
    category: '电影',
    categorySlug: 'dianying',
    updateTime: '12小时前更新',
    episode: '4K超清',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20style%2C%20courtroom%20theme%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20professional%20film%20poster%20composition&width=800&height=450&seq=latest-08&orientation=landscape',
  },
];

export const articles = [
  {
    id: 201,
    slug: '2025-nian-zuishou-qidai-guochan-ju',
    title: '2025年最受期待的十部国产剧盘点',
    excerpt: '新的一年，国产剧市场百花齐放。古装、悬疑、都市各类题材精彩纷呈，本文为您盘点了今年最值得期待的十部国产电视剧，从演员阵容到制作班底，带您先睹为快。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20illustration%2C%20TV%20drama%20collage%20style%2C%20editorial%20photography%2C%20warm%20golden%20lighting%2C%20cultural%20Chinese%20aesthetic%2C%20magazine%20quality%20composition&width=400&height=300&seq=article-01&orientation=landscape',
    author: '影视观察员',
    date: '2025-06-15',
    readCount: '12.8万',
    category: '剧集推荐',
    content: '',
  },
  {
    id: 202,
    slug: 'guochan-dongman-rising',
    title: '国产动漫崛起之路：从模仿到创新的华丽转身',
    excerpt: '近年来，国产动漫产业蓬勃发展，从《哪吒之魔童降世》到《深海》，再到《长安三万里》，国产动漫在技术和叙事上不断突破，逐渐形成了自己的风格和语言体系。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20industry%20illustration%2C%20donghua%20art%20style%2C%20editorial%20photography%2C%20creative%20colorful%20lighting%2C%20modern%20Chinese%20aesthetic%2C%20magazine%20quality&width=400&height=300&seq=article-02&orientation=landscape',
    author: '动漫评论家',
    date: '2025-05-28',
    readCount: '9.6万',
    category: '行业观察',
    content: '',
  },
  {
    id: 203,
    slug: 'zhenren-xiu-zongyi-fazhan',
    title: '真人秀综艺的进化：从娱乐到社会价值',
    excerpt: '国产综艺节目正在经历深刻转型，从单纯的娱乐搞笑到关注社会议题、传递正向价值。《种地吧》《我在岛屿读书》等节目让观众看到了综艺的更多可能性。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20illustration%2C%20reality%20TV%20theme%2C%20editorial%20photography%2C%20bright%20natural%20lighting%2C%20outdoor%20scene%2C%20modern%20documentary%20style&width=400&height=300&seq=article-03&orientation=landscape',
    author: '综艺深度',
    date: '2025-05-20',
    readCount: '7.3万',
    category: '综艺评论',
    content: '',
  },
  {
    id: 204,
    slug: 'jilupian-paished-behind',
    title: '一部纪录片背后的故事：镜头之外的真实',
    excerpt: '纪录片看似客观，实则每一个镜头都凝聚着导演和团队的思考与选择。本文带你走进纪录片制作的幕后，了解那些不为人知的拍摄故事和创作理念。',
    image: 'https://readdy.ai/api/search-image?query=documentary%20filmmaking%20behind%20scenes%20illustration%2C%20camera%20crew%20at%20work%2C%20editorial%20photography%2C%20natural%20warm%20lighting%2C%20authentic%20storytelling%20mood%2C%20magazine%20quality&width=400&height=300&seq=article-04&orientation=landscape',
    author: '纪录中国',
    date: '2025-05-10',
    readCount: '5.2万',
    category: '幕后故事',
    content: '',
  },
];

export const faqs = [
  {
    question: '国产视频在线观看需要付费吗？',
    answer: '不需要！本站所有国产视频资源均为免费在线观看，无需注册会员，无需支付任何费用。我们致力于为广大用户提供高质量的国产影视内容免费播放服务，让每一位观众都能轻松享受精彩的国产视频。',
  },
  {
    question: '支持哪些设备观看国产视频？',
    answer: '我们的平台全面支持手机、平板、电脑等多种设备在线观看。无论您使用的是iOS、Android、Windows还是Mac系统，都可以通过浏览器流畅观看高清国产视频，无需下载任何APP，打开网页即可播放。',
  },
  {
    question: '视频更新频率是怎样的？',
    answer: '我们每天都会更新最新的国产视频资源，包括热播电视剧最新集数、新上映的国产电影、综艺节目的最新一期以及精品纪录片等内容。所有更新都会在首页及时展示，确保您不会错过任何精彩内容。',
  },
  {
    question: '国产视频的画质如何？',
    answer: '本站提供的国产视频资源支持多种清晰度选择，包括高清HD、全高清1080P和4K超清画质。您可以根据网络状况和设备性能自由选择合适的画质，享受最佳观看体验。',
  },
  {
    question: '如何快速找到想看的国产视频？',
    answer: '您可以通过首页的分类导航进入电视剧、电影、综艺、纪录片等不同频道浏览内容，也可以使用搜索功能直接查找您想看的视频。热门推荐和最新更新板块也会帮助您发现更多优质国产视频资源。',
  },
];

export const testimonials = [
  {
    name: '王先生',
    avatar: 'W',
    rating: 5,
    comment: '非常好用的国产视频平台，资源丰富更新快，画质清晰流畅，已经推荐给身边的朋友了！',
    date: '2025-06-20',
  },
  {
    name: '李女士',
    avatar: 'L',
    rating: 5,
    comment: '终于找到一个不需要下载APP就能免费看国产电视剧的网站了，片源齐全，分类清晰，体验很棒！',
    date: '2025-06-18',
  },
  {
    name: '张同学',
    avatar: 'Z',
    rating: 5,
    comment: '国产动漫资源很全，斗破苍穹、完美世界都能看，更新速度也很快，强烈推荐给二次元爱好者。',
    date: '2025-06-15',
  },
];